import { Card, CardContent, Divider, Grid, Stack } from '@mui/material'
import { Field } from 'formik'
import { TextField } from 'formik-material-ui'
import { useAppTranslation } from 'src/admin/core/hooks'
import { FormAsterisk } from 'src/admin/core'
import { User } from '../../users/models'

export const ReadOnlyForm = ({ user }: { user: User }) => {
  const { label } = useAppTranslation()

  return (
    <Card>
      <Divider />
      <CardContent>
        <Stack spacing={2}>
          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormAsterisk validate={true}>
                <Field
                  fullWidth
                  component={TextField}
                  type="text"
                  label={label('NOMBRE')}
                  name="givenName"
                  disabled={true}
                />
              </FormAsterisk>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormAsterisk validate={true}>
                <Field
                  fullWidth
                  component={TextField}
                  type="text"
                  label={label('APELLIDO')}
                  name="familyName"
                  disabled={true}
                />
              </FormAsterisk>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormAsterisk>
                <Field
                  fullWidth
                  component={TextField}
                  type="text"
                  label={label('APODO')}
                  name="nickname"
                  disabled={true}
                />
              </FormAsterisk>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormAsterisk>
                <Field
                  fullWidth
                  component={TextField}
                  type="text"
                  label={label('DOCUMENTO')}
                  name="documentId"
                  disabled={true}
                />
              </FormAsterisk>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormAsterisk validate={true}>
                <Field
                  fullWidth
                  component={TextField}
                  type="email"
                  label={label('EMAIL')}
                  name="email"
                  disabled={true}
                />
              </FormAsterisk>
            </Grid>
          </Grid>
        </Stack>
      </CardContent>
    </Card>
  )
}
